// extracted by mini-css-extract-plugin
module.exports = {"card":"style-module__card___3mpbW","subjectName":"style-module__subjectName___1g5ak","detailsButton":"style-module__detailsButton___3xW9N"};